import { accessNested } from 'utils/utils';

// Gets a value, and replaces %$THING% by other values from an object recursively
// Example:
// copy = {
// 	'$MSG': 'Hello %$NAME%',
// 	'$NAME': '%$FIRST_NAME% %$SURNAME%',
// 	'$FIRST_NAME': 'John',
// 	'$SURNAME': 'Doe'
// };
// stringWithParams(copy, '$MSG'); // Hello John Doe
// stringWithParams(copy, 'Bye %$NAME%'); // Bye John Doe (if attribute is not a copy element, it uses that value directly)
// stringWithParams(copy, '%$FIRST_NAME% is %$MOOD%'); // John is $MOOD (if a variable is not defined, outputs its name)
// stringWithParams(copy, '100% with %$SURNAME%'); // 100% with Doe (a % sign alone still works)
// stringWithParams(copy, 'a \\%protected% part'); // a %protected% part (prepend with a \ to prevent parsing ; warning : needs to be doubled in string literals because of default JS escaping)
function _stringWithParams(params, str, _n) {
	// Prevent infinite recursion (e.g. $A = %$B%, $B = %$A%)
	if (++_n > 10) return str;
	// Allow using %subObject.$VALUE%
	const content = str === '' ? '' : accessNested(params, str, str) + '';
	return content.replace(/(\\)?%([^% ]+)%/g, (m, s, g) => s ? '%' + g + '%' : _stringWithParams(params, g, _n));
}
export default function stringWithParams(params, str) {
	return _stringWithParams(params, str, 0);
}